import React from 'react';
import { Create, SimpleForm, TextInput, required, useTranslate } from 'react-admin';
import { FormPageTitle, FormSection, FormToolbar } from '@/components/shell';

const BACK_TO = '/kyc-config?tab=nationalities';

export const NationalityCreate = () => {
  const t = useTranslate();
  return (
    <Create actions={<FormPageTitle mode="create" />}>
      <SimpleForm toolbar={<FormToolbar backTo={BACK_TO} />}>
        <FormSection title={t('resources.nationalities.name', { smart_count: 1 })}>
          <TextInput source="name" label={t('resources.nationalities.fields.name')} validate={required()} fullWidth />
        </FormSection>
      </SimpleForm>
    </Create>
  );
};
